import { useContext } from "react";
import { Redirect, Route } from "react-router";
import AuthContext from "../context/AuthContext";


export const PrivateRoute = ({ component: Component, ...restoProps }) => {
    const { myUser } = useContext(AuthContext);
//    console.log( `${myUser.email}`);
    return (
        <Route {...restoProps}> { (myUser.email !== undefined ) && (myUser.email !== '' )  ?  <Component /> : <Redirect to='/login' />} </Route>
    );

};

